import React from 'react';
import UserProfile from '../components/UserProfile.jsx';

const Profile = () => {
    return (
        <div className='App'>
            <div className='home'>
                <div className='homeBlock'>
                    <h2 data-test="userProfile" className="title">user profile</h2>
                    <UserProfile />
                </div >
            </div >
        </div >
    )
}

export default Profile